import { createBrowserRouter } from "react-router-dom"
import Homepage from '../views/Homepage'
import QRCode from '../views/QRCode'
import Camera from '../views/Camera'
import Error from '../views/Error'
import Template from '../views/Template'


function wrapWithTemplate(component,props){
    return <Template {...props} >{component}</Template>
}


export function getRouterConfiguration(){
    return createBrowserRouter([
        {
          path: "/", element: wrapWithTemplate(<Homepage />,{title:"App",back:false,settings:true}), errorElement: <Error />
        },
        {
            path: "/qrcode", element: wrapWithTemplate(<QRCode />,{title:"Scan",back:true}), errorElement: <Error />
        },
        {
            path: "/camera", element: wrapWithTemplate(<Camera />,{title:"Take Image",back:true}), errorElement: <Error />
        }
      ])
}

export function goToQRCode(navigate){
    navigate('/qrcode')
}

export function goToCamera(navigate){
    navigate('/camera')
}

export function goBack(navigate){
    navigate(-1)
}